<template>
    <td class="j-table-col">
        <slot></slot>
    </td>
</template>